// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3E6Pd","footer":"ModalInfo_footer__2twdM"};